import styled from "@emotion/styled";
import myThemes from "../../themes/Themes";

export const StyledBannerInfo = styled("div")(({}) => ({
  backgroundColor: "white",
  padding: "1.5rem",
  paddingBottom: "3rem",
  borderRadius: "10px",
  fontFamily: "Inter",
  boxSizing: "border-box",
  height: "100%"
}));
